import './contacts.scss'
import phone from './phone.svg'

function Contacts() {
    return(
        <div className='contacts'>
            <h2 className='contacts__header'>
                We're here to make your website awesome.
            </h2>
            <button className='contacts__button'>
                <img src={phone} alt='phone' className='icon'/>  Get  in touch with us
            </button>
        </div>
    )
}

export default Contacts
